module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("\n        Vouchers\n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Voucher\n      ")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    staticClass: "form-box margin-t20"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('img', {
    staticClass: "rule-color",
    attrs: {
      "src": require("../../../../static/email/signature/rule_color.png"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("Obs.: O(s) TAG(s) será(ão) ativado(s) somente após a validação do respectivo Voucher pelo Parceiro.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row margin-t20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "title-doc-left upper bold"
  }, [_vm._v("TITULAR")]), _vm._v(" "), _c('p', {
    staticClass: "title-doc-right credit"
  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-doc-right"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "three-dots margin-l5"
  }, [_vm._v(_vm._s(_vm.nomeCliente) + "  ")]), _vm._v(" "), _c('p', {
    staticClass: "three-dots margin-l5"
  }, [_vm._v(_vm._s(_vm.contractId) + "  ")]), _vm._v(" "), _c('p', {
    staticClass: "three-dots margin-l5"
  }, [_vm._v(_vm._s(_vm.$route.params.orderId) + "  ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "title-value-left upper bold"
  }, [_vm._v("VOUCHER(s)")]), _vm._v(" "), _c('p', {
    staticClass: "title-value-right"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.vouchers), function(v) {
    return _c('p', {
      key: v.voucher,
      staticClass: "three-dots text-center bold value-receipt"
    }, [_vm._v(_vm._s(v.voucher) + " - Status: " + _vm._s(v.descricao) + "  ")])
  }), 0), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v("   ")])])])]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Para retirar o(s) TAG(s) você precisa  :")])], 1)]), _vm._v(" "), _c('p', [_c('b', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("• Apresentar Voucher(s)")])], 1)]), _vm._v(" "), _c('p', [_c('b', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("• Documento de identificação com foto")])], 1)]), _vm._v(" "), _c('p', [_c('b', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("• Documento do veículo com número do RENAVAM")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('b', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("O cliente é responsável pela correta associação da placa e ativação do Tag, que será realizada no momento da retirada no parceiro.")])], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row hidden-print"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "margin-t20"
  }, [_c('div', {
    staticClass: "back-button-box"
  }, [_c('router-link', {
    staticClass: "btn btn-back",
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n            Voltar\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "action-buttons-box"
  }, [_c('button', {
    staticClass: "btn btn-back",
    on: {
      "click": function($event) {
        return _vm.window.print()
      }
    }
  }, [_vm._v("\n            Imprimir\n            "), _c('i', {
    staticClass: "icon-printer align-icon-left"
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticClass: "logo-receipt",
    attrs: {
      "src": require("../../../../static/logo-move-mais-balance-header.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('br'), _vm._v(" "), _c('h4', {
    staticClass: "title-receipt"
  }, [_vm._v("VOUCHER(S) PARA RETIRADA DE TAG(S) NOS PARCEIROS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "title-toll-left upper bold"
  }, [_vm._v("DADOS DA MOVE MAIS")]), _vm._v(" "), _c('p', {
    staticClass: "title-toll-right"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "box-toll-left"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "three-dots bold text-right margin-r5"
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('p', {
    staticClass: "three-dots bold text-right margin-r5"
  }, [_vm._v("IE:")]), _vm._v(" "), _c('p', {
    staticClass: "three-dots bold text-right margin-r5"
  }, [_vm._v("WEB:")]), _vm._v(" "), _c('p', {
    staticClass: "three-dots bold text-right margin-r5"
  }, [_vm._v("E-MAIL:")]), _vm._v(" "), _c('p', {
    staticClass: "three-dots bold text-right margin-r5"
  }, [_vm._v("TEL:")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-toll-right"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "three-dots margin-l5"
  }, [_vm._v("15.266.912/0001-87")]), _vm._v(" "), _c('p', {
    staticClass: "three-dots margin-l5"
  }, [_vm._v("206.318.529.117")]), _vm._v(" "), _c('p', {
    staticClass: "three-dots margin-l5"
  }, [_vm._v("www.movemais.com/#/contato")]), _vm._v(" "), _c('p', {
    staticClass: "three-dots margin-l5"
  }, [_vm._v("relacionamento@movemais.com")]), _vm._v(" "), _c('p', {
    staticClass: "three-dots margin-l5"
  }, [_vm._v("0800 777 1022/4000 2901(Capitais)")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-doc-left"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "three-dots bold text-right margin-r5"
  }, [_vm._v("Nome do cliente:")]), _vm._v(" "), _c('p', {
    staticClass: "three-dots bold text-right margin-r5"
  }, [_vm._v("N° do Contrato:")]), _vm._v(" "), _c('p', {
    staticClass: "three-dots bold text-right margin-r5"
  }, [_vm._v("N° do Pedido:")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-aa9b4728!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/request/conveniado-voucher.vue
// module id = 2199
// module chunks = 1